import React, { Component } from 'react'
import DataTable from 'react-data-table-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit,faTrash,faUser} from '@fortawesome/free-solid-svg-icons';

import ToastComp from '../../../components/Toast/Toast';
import axios from 'axios';
import { API } from '../../../config/API';
import Loader from '../../../components/Loader/Loader';
import LaunchEval from './LaunchEval';

export default class Evaluation extends Component {
  
constructor(){
    super();
    this.rowData = {};
    this.columns =  [
      {
        id: "id",
          name: 'ID',
          selector: row => row.assessmentId,
          grow:0.5
      },
      {
          name: 'TITLE',
          selector: row => row.assessmentName,
        
      },
      {
        name: 'SUBMITTED BY',
        selector: row => row.userName,
       
      },
      {
        cell:(row) => <button id={row.id} className='btn btn-info' onClick={()=>this.reviewTest(row)}> <FontAwesomeIcon icon={faEdit} className='table-icon-inline'/>LAUNCH</button>,
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        width:"150px"
      },
   
  ];
  this.dataObj={};
    this.state = {
        loader:false,
        data:[],
        fullData:[],
        startEval:false,
        errorToggle:false
    }
    
}
componentDidMount(){
  this.listItems();
 }
 //Search fn
filterData = (e)=>{
  const key = e.target.value;
  let ar=[];
  this.state.fullData.forEach(element => {
    if(element.name.toLowerCase().indexOf(key.toLowerCase())>-1) 
    ar.push(element);
  });
  this.setState({data : ar})
}
 //List tests
 listItems =()=>{
  this.setState({startEval:false});
  this.setState({loader:true});
  axios.get(API.reviewAssessment).then((res)=>{
    if(res && res.data && res.data.status ==="S"){
      const data = res.data.data ;
      this.setState({data});
      this.setState({fullData: data})
    }
    this.setState({loader:false});
  }).catch((er)=>{
    this.setState({loader:false});
  })
}
reviewTest=(obj)=>{
  this.dataObj = obj;
  this.setState({startEval:true});
}
updateTestResult=(req)=>{
  this.setState({loader:true});
  axios.post(API.evaluateAssessment,req).then((res)=>{
    if(res && res.data && res.data.status ==="S"){
      this.setState({successToggle:true});
    }else{
      this.setState({errorToggle:true});
    }
  }).catch((er)=>{
    this.setState({errorToggle:true});
  }).finally(()=>{
    setTimeout(() => {
      this.setState({loader:false});
      this.listItems();
    }, 500);
  })
}
  render() {
    
    return (
      <div>
        <Loader loading={this.state.loader}></Loader>
        {this.state.errorToggle ? <ToastComp case='error' handler={()=>{this.setState({errorToggle:false})}}/> : ""}
        {this.state.successToggle ? <ToastComp case='update-test' handler={()=>{this.setState({successToggle:false})}}/> : ""}
        {this.state.startEval ? <LaunchEval callback={(req)=>this.updateTestResult(req)} data={this.dataObj} flag={this.state.startEval} handler={()=>this.setState({startEval:false})}/> : ""}
      
      <div className='bread-crumb overflow-auto'>
      <div>
      <span className='breadcrumb-title'>
        <input type='button' className='btn' value='Home - Evaluation'></input>
      </span>
     
      </div>
      </div>
      <div className='data-table-holder'>
        <div className='table-search-box'>
        <input type='text' placeholder="Search Here.." className='form-control' onChange={(e)=>this.filterData(e)} ></input>
        </div>
      <DataTable
      columns={this.columns} defaultSortFieldId="id"
      data={this.state.data} pagination striped
     
      />
      </div>
      </div>
    )
  }
}
